import { Helmet } from "react-helmet";
import { Box, Container, Fade, Skeleton, styled, Table, TableBody, tableBodyClasses, TableCell, tableCellClasses, TableContainer, TableHead, tableHeadClasses, TableRow, Typography } from "@mui/material";
import Toasty from "../../../theme/components/Toasty";
import { getTransactions } from "../../../lib/services/drive";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Pagination } from "../../../theme/components/Pagination";
import { CancelOutlined, DoneRounded, ReportRounded } from "@mui/icons-material";
import { farsiHour, farsiDate } from "../../../lib/commonFunctions/dateConvertor";

export default function Transactions() {

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get('page') || '1');
    const [perPage, setPerPage] = useState(searchParams.get('size') || '10');
    const [pagesCount, setPagesCount] = useState(0);

    const navigate = useNavigate();

    async function getData() {
        try {
            const { data } = await getTransactions(page, perPage);
            if (data?.isSuccess) {
                setTransactions(data.value?.data);
                setPagesCount(Math.ceil(data.value?.countData / perPage));
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setLoading(false);
    }

    // Get Data
    useEffect(() => {
        if (loading) {
            getData();
        }
    }, [page, loading]);
    // Change Page
    useEffect(() => {
        if (page) {
            navigate(`/drive/transactions?page=${page}&size=${perPage}`);
            window.scrollTo({ top: 0, behavior: "smooth" })
            setLoading(true);
        }
    }, [page]);

    return (
        <>
            <Helmet>
                <title>درایو میلفا - تراکنش ها</title>
            </Helmet>
            <Container sx={{ mt: 3 }}>
                <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600}>لیست تراکنش های اخیر</Typography>
                <TableContainer sx={{ mt: 3 }}>
                    <StyledTable>
                        <TableHead>
                            <TableCell>نوع تراکنش</TableCell>
                            <TableCell>مقدار</TableCell>
                            <TableCell>وضعیت</TableCell>
                            <TableCell>پرداخت آنلاین</TableCell>
                            <TableCell>تاریخ</TableCell>
                        </TableHead>
                        <TableBody>
                            {!loading
                                ?
                                transactions.length
                                    ?
                                    transactions.map((t, ind) => (
                                        <TableRow key={ind}>
                                            <TableCell>{t.kind?.toLocaleString('fa-IR')}</TableCell>
                                            <TableCell>{t.amount?.toLocaleString('fa-IR')} ریال</TableCell>
                                            <TableCell>
                                                {t.settled
                                                    ?
                                                    <Typography color="success.dark" fontSize="inherit">پرداخت شده</Typography>
                                                    :
                                                    <Typography color="error.dark" fontSize="inherit">پرداخت نشده</Typography>
                                                }
                                            </TableCell>
                                            <TableCell><YesOrNo boolean={t.onlinePayment} /></TableCell>
                                            <TableCell>{`${farsiHour(t.date)} - ${farsiDate(t.date)}`}</TableCell>
                                        </TableRow>
                                    ))
                                    :
                                    <TableRow>
                                        <TableCell colspan="5"><NothingFound /></TableCell>
                                    </TableRow>
                                :
                                <LoadingSkeleton />
                            }
                        </TableBody>
                    </StyledTable>
                </TableContainer>

                <Fade in={!loading}>
                    <Box my={5} display='flex' alignItems='center' justifyContent='center'>
                        <Pagination
                            page={parseInt(page)}
                            onChange={(e, newPage) => setPage(newPage)}
                            count={pagesCount} />
                    </Box>
                </Fade>

            </Container>
        </>
    )
}

const StyledTable = styled(Table)(({ theme }) => ({
    [`& .${tableCellClasses.root}`]: { whiteSpace: "noWrap", textAlign: "center" },
    [`& .${tableHeadClasses.root} .${tableCellClasses.root}`]: {
        background: theme.palette.primary.light,
        color: "initial",
    },
    [`& .${tableHeadClasses.root} .${tableCellClasses.root}:first-of-type`]: {
        borderRadius: "5px 0 0 0"
    },
    [`& .${tableHeadClasses.root} .${tableCellClasses.root}:last-of-type`]: {
        borderRadius: "0 5px 0 0"
    },
    [`& .${tableBodyClasses.root}`]: {
        background: theme.palette.grey.main,
    }
}));
const YesOrNo = ({ boolean }) => {
    switch (boolean) {
        case true: return <DoneRounded color="success" fontSize="small" />
        case false: return <CancelOutlined color="error" fontSize="small" />;
        default: return <CancelOutlined color="error" fontSize="small" />;
    }
}
const LoadingSkeleton = () => {
    return (
        Array.from([...Array(10)]).map((_, ind) => (
            <TableRow key={ind}>
                <TableCell><Skeleton width="100%" /></TableCell>
                <TableCell><Skeleton width="100%" /></TableCell>
                <TableCell><Skeleton width="100%" /></TableCell>
                <TableCell><Skeleton width="100%" /></TableCell>
                <TableCell><Skeleton width="100%" /></TableCell>
            </TableRow>
        ))
    )
}
const NothingFound = () => {
    return (
        <Box width={1} minHeight="15rem" display="flex" alignItems="center" justifyContent="center" flexDirection="column">
            <ReportRounded color="warning" sx={{ fontSize: "2.5rem" }} />
            <Typography mt={1} fontSize="1.1rem" fontWeight={600}>هیچ تراکنشی یافت نشد</Typography>
        </Box>
    )
}